import {Component, input} from '@angular/core';
import {WineProduct} from '@core/interfaces/generated/graphql';
import {NgOptimizedImage} from '@angular/common';
import {NgbTooltip} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-product-quick-info',
  templateUrl: './product-quick-info.component.html',
  styleUrls: ['./product-quick-info.component.scss'],
  imports: [
    NgOptimizedImage,
    NgbTooltip
  ]
})
export class ProductQuickInfoComponent {

  product = input.required<WineProduct | undefined>();

}
